import { Route, Routes, useParams } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";

import IdpGroupPageLayout from "./PageLayout";
import IdpGroupRoles from "./Roles";
import useGetIdpGroup from "./useGetIdpGroup";
import IdpGroupUsers from "./Users";

const IdpGroup = () => {
  const { idpGroupId } = useParams<{ idpGroupId: string }>();
  const { idpGroup, error, loading, refetch } = useGetIdpGroup({
    id: idpGroupId,
  });

  if (loading && !idpGroup) {
    return <PageLoading />;
  }

  if (!idpGroup) {
    return <NotFoundPage />;
  }

  if (error) {
    return null;
  }

  return (
    <IdpGroupPageLayout idpGroup={idpGroup}>
      <Routes>
        <Route
          index
          element={
            <IdpGroupRoles
              idpGroupId={idpGroup.id}
              roleBindings={idpGroup.userRoleBindings}
              groupName={idpGroup.groupName}
              refetch={refetch}
            />
          }
        />
        <Route
          path="users"
          element={<IdpGroupUsers users={idpGroup.managedUsers} groupName={idpGroup.groupName} />}
        />
      </Routes>
    </IdpGroupPageLayout>
  );
};

export default IdpGroup;
